import { useState, useEffect, useMemo } from "react";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  TitleContainer,
  Label,
  Input,
  InputContainer,
} from "./UsernameModal.styles";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "../modern-ui/sonner";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import { changeUsername } from "../../store/slices/user/asyncThunk";
import {
  selectSetUsernamePending,
  selectUser,
} from "../../store/slices/user/slice";
import Button from "../utils/Button/Button";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";

const UsernameModal = ({ isOpen, onClose }) => {
  useLockBodyScroll(isOpen);
  const loading = useSelector(selectSetUsernamePending);
  const user = useSelector(selectUser);
  const [username, setUsername] = useState("");

  const dispatch = useDispatch();

  const hasUsername = useMemo(() => {
    return !user?.username?.includes("-");
  }, [user]);

  useEffect(() => {
    if (hasUsername && user) {
      setUsername(user.username);
    }
  }, [hasUsername, user, isOpen]);

  const handleSetUsername = () => {
    if (!username || username.trim().length < 3) {
      toast.error("Username must be at least 3 characters long");
      return;
    }

    if (!/^[a-zA-Z0-9_]+$/.test(username)) {
      toast.error(
        "Username can only contain letters, numbers, and underscores",
      );
      return;
    }

    dispatch(changeUsername({ username }))
      .unwrap()
      .then(() => {
        toast.success("Username set successfully!");

        onClose();
      })
      .catch((err) => {
        toast.error("Please choose a different username");
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onAfterClose={() => {
        setUsername("");
      }}
    >
      <ModalContainer>
        <ModalContent>
          <TitleContainer>
            <ModalTitle>
              {hasUsername ? "Change Username" : "Set Username"}
            </ModalTitle>
            {hasUsername && (
              <CloseButton
                onClick={() => {
                  onClose();
                }}
              >
                <CloseSvg />
              </CloseButton>
            )}
          </TitleContainer>

          <InputContainer>
            <Label>Username</Label>
            <Input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </InputContainer>
          <Button
            onClick={handleSetUsername}
            disabled={loading || !username.trim()}
            title={"Save"}
            loading={loading}
            style={{ width: "100%" }}
          />
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default UsernameModal;
